
export const NoResults = () => {
  return (
    <div className="rounded-lg bg-secondary-grey-05 text-black p-8 space-y-4">
        <h3 className="font-bold">Sorry, we couldn't find any results</h3>
        <h5 className="font-bold">Let's try again:</h5>
        <ul className="list-disc ml-6 text-[#4b4b4b] text-sm space-y-2">
            <li>Try searching with different keywords.</li>
            <li>Double-check the filters you've applied.</li>
        </ul>
    </div>
  );
};
